export default __webpack_public_path__ + "static/financial-freedom-dark-c5ea2dfd21e41e1e8c12325c6a302bd3.svg";